<template>
  <div class="page">
    <div class="app-container">
      <el-button type="primary" @click="add">新增</el-button>
      <BaseTable
        ref="baseTable"
        url="/admin/carHeTong/getTerm"
        :tableData.sync="tableData"
        :columns="columns"
        :searchParams="searchData"
      >
        <template #handle="{ row }">
          <el-button type="text" size="mini" @click="edit(row)">编辑</el-button>
          <el-button type="text" size="mini" @click="del(row)">删除</el-button>
        </template>
      </BaseTable>
      <BaseDialog
        :visible.sync="dialogVisible"
        title="服务条款"
        @confirm="handleDialogConfirm"
		width = "60%"
      >
        <BaseForm
          ref="baseForm"
          v-model="formData"
          :formOptions="formOption"
          :rules="rules"
          itemWidth="100%"
        ></BaseForm>
      </BaseDialog>
    </div>
  </div>
</template>

<script>
import { columns,formOption,rules } from "./columns";

export default {
  name: "Term",
  comments: {},
  data() {
    return {
	  tableData: [],
      searchData: {},
	  formData: {
		  pid: 0,
		  name: '',
		  amount: '',
		  amountFee: ''
	  },
	  dialogVisible: false,
	  detailType: []
    };
  },
  computed: {
    columns,
	formOption,
	rules
  },
  created() {},
  methods: {
    add() {
	  this.formData = {};
      this.dialogVisible = true;
    },

    edit(row) {
      this.formData = { ...row };
      this.dialogVisible = true;
    },
    del(row) {
      this.$confirm("是否确认删除该服务条款, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.$api
            .post(
              "/admin/carHeTong/delTerm",
              {
                id: row.id,
              },
              "删除"
            )
            .then(() => {
              this.$refs.baseTable.searchData();
            });
          this.handleSearch();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
	// 提交
	handleDialogConfirm(cb) {
		// 用来结束loading
		this.$refs.baseForm.onSubmit(async (validate) => {
		  if (validate) {
		    const confirm = await this.$confirm('是否确认提交？', '提示', {
		      confirmButtonText: '确定',
		      cancelButtonText: '取消',
		      type: 'warning',
		    }).catch(() => {});
		    if (confirm) {
				const data = this.formData;
		      await this.$api.post('/admin/carHeTong/saveTerm', { 
				  'id': data.id,
				  'title': data.title,
				  'mark': data.mark,
				  'content': data.content,
				  'content_two': data.content_two,
				  //'content_three': data.content_three,
			  }, '服务条款提交');
		      this.dialogVisible = false;
		      this.handleSearch();
		    }
		    cb(false);
		  } else {
		    cb();
		  }
		});
	},

    // 点击搜索
    handleSearch() {
      // console.log(this.searchData);
      this.$refs.baseTable.searchData();
    },
    // 搜索参数拦截
    paramsCepCallback(params) {
      // console.log(params);
      return {
        ...params,
        ...this.searchData,
      };
    },
  },
};
</script>
